"use client";

import { useEffect } from "react";
import { ErrorScreen } from "@/components/ErrorScreen";
import { clientLog } from "@/lib/observe/client";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { void clientLog.error({kind:"route_error_boundary",error,route:window.location.pathname,payload:{digest:error.digest}}); },[error]);
  return <ErrorScreen retry={reset} />;
}
